import React, { Component } from "react";
import {  Icon } from "@mui/material";


class FactsDesignerDummy extends Component{
  
    render(){
        return (
          <div
            className="factsDesignerDummy"
            style={{
              backgroundColor: "#ffeb3b",
              color: "grey",
              padding: "5px",
              display: "flex",
              alignItems: "center",
            }}
            {...this.props}
          >
            <Icon
              style={{ pointerEvents: "none" }}
              className="factsDesignerDummyIcon"
            >
              data_object
            </Icon>
            {this.props.type}
          </div>
        );
    }
}

export default FactsDesignerDummy; 